module.exports = __webpack_public_path__ + "static/gmail-logo-da93499d5840c8f44be96d66a66fedbd.png";